<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-field 
            :editable="editable"
            type="user" 
            label="안전관리자" 
            name="envDangerManageUserId" 
            v-model="searchParam.envDangerManageUserId" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-field 
            :editable="editable"
            type="user" 
            label="담당자" 
            name="envDangerUserId" 
            v-model="searchParam.envDangerUserId" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-field 
            :editable="editable"
            type="user" 
            label="안전대리자" 
            name="envDangerSafetyUserId" 
            v-model="searchParam.envDangerSafetyUserId" />
        </div>
        <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2">
          <c-select
            :editable="editable"
            type="search"
            :comboItems="useFlagItems"
            itemText="codeName"
            itemValue="code"
            label="사용여부"
            name="useFlag"
            v-model="searchParam.useFlag">
          </c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="위험물 저장소 목록"
      :columns="grid.columns"
      :data="grid.data"
      :merge="grid.merge"
      rowKey="envDangerMstId"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <div>
          <q-btn-group outline>
            <c-btn label="등록" v-if="editable" :editable="editable" icon="add" @btnClicked="onItemClick" />
            <c-btn label="검색" icon="search" @btnClicked="getList" />
          </q-btn-group>
        </div>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: "danger-master",
  data() {
    return {
      grid: {
        columns: [
          {
            name: "plantName",
            field: "plantName",
            label: "사업장",
            style: 'width:100px',
            align: "center",
            sortable: true,
          },
          {
            name: "envDangerArea",
            field: "envDangerArea",
            label: "설치장소",
            style: 'width:200px',
            align: "left",
            sortable: true,
          },
          {
            name: "envDangerManageUserName",
            field: "envDangerManageUserName",
            label: "안전관리자",
            style: 'width:100px',
            align: "center",
            sortable: true,
          },
          {
            name: "envDangerMstName",
            field: "envDangerMstName",
            label: "품명",
            style: 'width:300px',
            align: "left",
            sortable: true,
            type: "link",
          },
          {
            name: "envDangerUserName",
            field: "envDangerUserName",
            style: 'width:200px',
            label: "담당자",
            align: "center",
            sortable: true,
          },
          {
            name: "envDangerSafetyUserName",
            field: "envDangerSafetyUserName",
            style: 'width:200px',
            label: "안전대리자",
            align: "center",
            sortable: true,
          },
          {
            name: "envDangerCount",
            field: "envDangerCount",
            style: 'width:250px',
            label: "지정수량",
            align: "left",
            sortable: true,
          },
          {
            name: "envDangerMainUse",
            field: "envDangerMainUse",
            style: 'width:150px',
            label: "주용도",
            align: "left",
            sortable: true,
          },
          {
            name: "useFlagName",
            field: "useFlagName",
            style: 'width:60px',
            label: "사용여부",
            align: "center",
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: null,
        useFlag: 'Y',
        envDangerManageUserId: '',
        envDangerUserId: '',
        envDangerSafetyUserId: '',
      },
      useFlagItems: [ // 사용여부
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      editable: true,
      searchUrl: "",
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      isResult: false,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.env.danger.master.list.url;
      // url setting
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    /* eslint-disable no-unused-vars */ 
    onItemClick() {
      this.linkClick(null);
    },
    linkClick(row, col, index) {
      this.popupOptions.title = "위험물저장소 상세"; // 위험물저장소 상세
      this.popupOptions.param = {
        envDangerMstId: row ? row.envDangerMstId : '',
      };
      this.popupOptions.target = () =>
        import(`${"./dangerMasterDetail.vue"}`);
      this.popupOptions.width = "90%"
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(type) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  },
};
</script>
